export function initJCFSelect () {

        jcf.setOptions({
        wrapNative: false,
        maxVisibleItems: 12,
        handleResize: true,
        alwaysShowScrollbars: true,
        alwaysPreventMouseWheel: true,
        mouseWheelStep: 40
    });

    jcf.replaceAll();
    $(window).on("load", function () {
        jcf.replaceAll();
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/jcf-init.js